import { useSelector, shallowEqual } from 'react-redux';
import {
  hasOveragesPermissionSelector,
  hasShortagesPermissionSelector,
  hasDamagesPermissionSelector,
  hasOnHandDeliveryPermissionSelector,
  hasMisdeliveryPermissionSelector,
  hasClearedPermissionSelector,
} from '../AppState/selectors';
import AppState from '../AppState';

const usePermissions = () => {
  const {
    hasOveragesPermission,
    hasShortagesPermission,
    hasDamagesPermission,
    hasOnHandDeliveryPermission,
    hasMisDeliveryPermission,
    hasClearedPermission,
  } = useSelector((state: AppState) => ({
    hasOveragesPermission: hasOveragesPermissionSelector(state),
    hasShortagesPermission: hasShortagesPermissionSelector(state),
    hasDamagesPermission: hasDamagesPermissionSelector(state),
    hasOnHandDeliveryPermission: hasOnHandDeliveryPermissionSelector(state),
    hasMisDeliveryPermission: hasMisdeliveryPermissionSelector(state),
    hasClearedPermission: hasClearedPermissionSelector(state),
  }), shallowEqual);

  return {
    overages: hasOveragesPermission,
    shortages: hasShortagesPermission,
    damages: hasDamagesPermission,
    onHandDelivery: hasOnHandDeliveryPermission,
    misDelivery: hasMisDeliveryPermission,
    cleared: hasClearedPermission,
  };
};

export default usePermissions;